export { default } from './SectionHeading';
